import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Microfrontend } from '@cian/mf-react';
import { useSelector } from 'react-redux';

import { useInfrastructureMicrofrontend } from './useInfrastructureMicrofrontend';
import {
  InfrastructureError,
  InfrastructureLoader,
  InfrastructureWrapper,
} from '../../components/InfrastructureMicrofrontend';
import { getMapApiKey, getSuggestApiKey } from '../../selectors/common';
import { getDisplayName } from '../../selectors/newbuilding';

interface IInfrastureMicrofrontendContainerProps {
  headerLinks?: React.ReactNode;
}

export function InfrastructureMicrofrontendContainer({ headerLinks }: IInfrastureMicrofrontendContainerProps) {
  const newbuildingName = useSelector(getDisplayName);

  // Микрофронт карты загружается только после того, как пользователь доскроллил до секции
  const [isViewed, setIsViewed] = React.useState(false);
  const handleViewed = React.useCallback(() => setIsViewed(true), []);

  const { manifest, fetchManifest, status } = useInfrastructureMicrofrontend(isViewed);

  const yandexApiKey = useSelector(getMapApiKey);
  const yandexSuggestApiKey = useSelector(getSuggestApiKey);

  const microfrontendParams = React.useMemo(
    () => ({
      yandexApiKey,
      yandexSuggestApiKey,
      profile: 'newbuilding',
    }),
    [yandexApiKey, yandexSuggestApiKey],
  );

  return (
    <ActionAfterViewObserver callback={handleViewed} percentVisible={0.1} triggerOnce>
      <InfrastructureWrapper headerLinks={headerLinks} title={`${newbuildingName} на карте`}>
        {status === 'loading' && <InfrastructureLoader />}
        {status === 'error' && <InfrastructureError retry={fetchManifest} />}
        {status === 'success' && manifest && (
          <Microfrontend
            name={manifest.microfrontendName}
            image={manifest.imageVersion}
            runtime={manifest.runtimeName}
            parameters={microfrontendParams}
          />
        )}
      </InfrastructureWrapper>
    </ActionAfterViewObserver>
  );
}
